export enum Packages {
    PFPF = "PFPF",
    PFF = "PFF",
    HF = "HF",
    PFPCS = "PFPCS",
    PFTT = "PFTT",
    HTT = "HTT",
    PFP = "PFP",
    PFCS = "PFCS",
    PF = "PF",
    PMA = "PMA",
    HS = "HS",
    PFTTF = "PFTTF",
    PFPTTF = "PFPTTF",
    PFTTNL = "PFTTNL",
    PFPTTNL = "PFPTTNL",
}